import queryString from 'query-string';
import React from 'react';
import { useLocation } from 'react-router-dom/cjs/react-router-dom';

import AppMigration from '../../app-migration/AppMigration';
import AppMigrationExport from '../../app-migration/AppMigrationExport';
import AppMigrationHistory from '../../app-migration/AppMigrationHistory';
import AppMigrationImport from '../../app-migration/AppMigrationImport';
import Layout from '../../components/Layout';
import * as Urls from '../../constants/Urls';

const AppMigrationPage = () => {
  const location = useLocation();

  const { type } = queryString.parse(location.search);
  const currentType = type;

  const getContent = (type) => {
    switch (type) {
      case 'export':
        return <AppMigrationExport type={type} />;
      case 'history':
        return <AppMigrationHistory />;
      case 'import':
        return <AppMigrationImport />;
      case 'packages':
        return <AppMigrationExport type={type} />;
      default:
        return <AppMigration />;
    }
  };

  return <Layout dashboardLink={Urls.APP_MIGRATION_PAGE}>{getContent(currentType)}</Layout>;
};
export default AppMigrationPage;
